/*
 * @Description: 
 * @Author: juanjuanhui
 * @Date: 2023-12-12 09:13:48
 * @LastEditors: likk 1126919170@qq.com
 * @LastEditTime: 2024-09-25 11:19:04
 */
import Vue from "vue";
import Vuex from "vuex";
import $api from '@/api/api';
import router from "@/router";
import axios from "axios";
//vuex数据持久化
import createPersistedState from "vuex-persistedstate"

Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    isWeixinBrowser:true,
    accessToken: "",//登录后生成
    otherAccessToken: "", //第三方token-未登录时使用
    // wfwAccessToken:"", // 微服务接口所需的accesstoken
    refreshToken: "",//刷新登录状态所需的token
    userInfo: null, //登录用户信息
  },
  mutations: {
    setIsWeixinBrowser(state, flag){
      state.isWeixinBrowser = flag;
    },
    setAccessToken(state, accessToken) {
      state.accessToken = accessToken;
    },
    setOtherAccessToken(state, otherAccessToken){
      state.otherAccessToken = otherAccessToken;
    },
    // setWFWAccessToken(state, accessToken){
    //   state.wfwAccessToken = accessToken;
    // },
    setUserInfo(state, userInfo){
      state.userInfo = userInfo;
    },
    clearStateDatas(state){
      state.accessToken = "";
      state.userInfo = null;//登录用户信息
    },
    setRefreshToken(state,refreshToken) {
      state.refreshToken = refreshToken;
    },
  },
  modules: {
    
  },
  actions: {
    //获取用户信息
    GetUserInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        $api.login.getUserInfo().then(res => {
          commit("setUserInfo",res)
          resolve(res);
          // setTimeout(() => {
            // router.push("/");
            window.location.replace("/");
          // },500)
        }).catch(res => {
          // localStorage.setItem("userInfo",null);
          reject(res)
        })
      })
    },
    // 登录
    Login({ commit, state },data){
      return new Promise((resolve, reject) => {
        $api.login.login(data).then(res => {
          commit("setAccessToken", res.access_token);
          commit("setRefreshToken", res.refresh_token);
          resolve(res)
        }).catch(res => {
          reject(res)
        })
      })
    },
    // 退出登录
    async LoginOut({commit,state}){
      commit("clearStateDatas");
      // localStorage.clear();
    },
    //刷新登录状态的token
    RefreshToken({commit},state){
      $api.login.refreshToken().then(res => {
        const { code, msg} = res.data;
        if(code == 401){
          commit("clearStateDatas");
          commit("setRefreshToken","");
          router.push("/login");
        }else{ 
          console.log("刷新成功！！！")
        }
      })
    },
    /**
     * @description: 获取第三方accessToken
     * @return {*}
     */    
    async GetOtherAccessToken({commit}){
      const { access_token } = await $api.common.getAccessToken({
        grant_type: 46,
        client_id: 100026,
      })
      commit('setOtherAccessToken', access_token);
    },
    /**
     * @description: 获取微服务接口所需的accessToken
     * @return {*}
     */    
    // async GetWFWAccessToken({commit}){
    //   const { access_token } = await $api.common.getWFWAccessToken();
    //   commit('setWFWAccessToken', access_token);
    // },

  },
  plugins: [createPersistedState({
      storage: window.localStorage
  })]
});
